import React from 'react';
import { connect } from 'react-redux';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { newContainerPick, newOrderPick, newContainerVerify, newContainerShippingAdd, newContainerMove, get, remove, update } from '~/actions/tasks';
import Spinner from '~/components/Spinner';
import UserPicker from '~/components/UserPicker';
import OrderPicker from '~/components/OrderPicker';
import ContainerPicker from '~/components/ContainerPicker';
import ArticlePicker from '~/components/ArticlePicker';
import LocationPicker from '~/components/LocationPicker';
import TaskPicker from '~/components/TaskPicker';
import MultiPicker from '~/components/MultiPicker';
import MultiPickerCount from '~/components/MultiPickerCount';
import styleDialog from '~/style/dialog.scss';
import styleLocal from './style.scss';

const types = {
  container_pick: {
    label: 'Container: pick articles',
    fields: [
      { id: 'containerId', label: 'Container', type: 'containerId', required: true },
      { id: 'parentTaskId', label: 'Parent tasks', type: 'taskIds' },
      { id: 'userId', label: 'Assigned user', type: 'userId' },
    ],
    onSubmit: (_this, fields) =>
      newContainerPick(_this.props.dispatch, _this.context.apiClient, fields)
        .then(r => _this.context.dialogPush('message', { content: 'Task created', subContent: `Id: #${r.data.task.sku}` })),
  },
  container_verify: {
    label: 'Container: verify articles',
    fields: [
      { id: 'containerId', label: 'Container', type: 'containerId', required: true },
      { id: 'parentTaskId', label: 'Parent tasks', type: 'taskIds' },
      { id: 'userId', label: 'Assigned user', type: 'userId' },
    ],
    onSubmit: (_this, fields) =>
      newContainerVerify(_this.props.dispatch, _this.context.apiClient, fields)
        .then(r => _this.context.dialogPush('message', { content: 'Task created', subContent: `Id: #${r.data.task.sku}` })),
  },
  container_shipping_add: {
    label: 'Container: add shipping',
    fields: [
      { id: 'containerId', label: 'Container', type: 'containerId', required: true },
      { id: 'parentTaskId', label: 'Parent tasks', type: 'taskIds' },
      { id: 'userId', label: 'Assigned user', type: 'userId' },
    ],
    onSubmit: (_this, fields) =>
      newContainerShippingAdd(_this.props.dispatch, _this.context.apiClient, fields)
        .then(r => _this.context.dialogPush('message', { content: 'Task created', subContent: `Id: #${r.data.task.sku}` })),
  },
  container_move: {
    label: 'Container: move',
    fields: [
      { id: 'containerId', label: 'Container', type: 'containerId', required: true },
      { id: 'locationId', label: 'Move to', type: 'locationId', required: true },
      { id: 'parentTaskId', label: 'Parent tasks', type: 'taskIds' },
      { id: 'userId', label: 'Assigned user', type: 'userId' },
    ],
    onSubmit: (_this, fields) =>
      newContainerMove(_this.props.dispatch, _this.context.apiClient, fields)
        .then(r => _this.context.dialogPush('message', { content: 'Task created', subContent: `Id: #${r.data.task.sku}` })),
  },
  order_pick: {
    label: 'Order: pick articles',
    fields: [
      { id: 'orderId', label: 'Order', type: 'orderId', required: true },
      { id: 'parentTaskId', label: 'Parent tasks', type: 'taskIds' },
      { id: 'userId', label: 'Assigned user', type: 'userId' },
    ],
    onSubmit: (_this, fields) =>
      newOrderPick(_this.props.dispatch, _this.context.apiClient, fields)
        .then(r => _this.context.dialogPush('message', { content: 'Task created', subContent: `Id: #${r.data.task.sku}` })),
  },
};

const fields = {
  orderId: OrderPicker,
  containerId: ContainerPicker,
  userId: UserPicker,
  articleId: ArticlePicker,
  articleIds: MultiPickerCount(ArticlePicker),
  taskIds: MultiPicker(TaskPicker),
  locationId: LocationPicker,
  taskId: TaskPicker,
};


class Dialog extends React.Component {
  static contextTypes = {
    dialogPush: React.PropTypes.func.isRequired,
    dialogClose: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: !!props.data.id,
    };
  }

  componentDidMount() {
    if (this.props.data.id) {
      get(this.props.dispatch, this.context.apiClient, this.props.data.id)
        .then(r => this.setState({ item: r.data.task, loading: false }));
    }
  }

  remove() {
    return remove(
      this.props.dispatch,
      this.context.apiClient,
      this.props.data.id
    ).then(() => this.context.dialogClose(this.props.dialogId));
  }

  renderCreate() {
    return (
      <div style={{ padding: '10px' }}>
        <div style={{ marginBottom: '10px' }}>New task - {types[this.state.type].label}</div>
        <form
          onSubmit={e => {
            e.preventDefault();
            const { type, loading, item, ...values } = this.state;
            types[this.state.type].onSubmit(
              this,
              values,
            );
            this.context.dialogClose(this.props.dialogId);
            if (this.props.data.onCreate) { this.props.data.onCreate(); }
          }}
        >
          {(types[this.state.type] ? types[this.state.type].fields : []).map(field =>
            <div className={styleLocal.titleRow} key={field.id}>
              {field.label && <div className={styleLocal.title}>
                {field.label}
                {field.required && <div className={styleLocal.required}>*</div>}
              </div>}
              <div className={styleLocal.value}>
                {(() => {
                  const Cmp = fields[field.type];
                  return Cmp ? <Cmp
                    key={field.id}
                    id={field.id}
                    value={this.state[field.id]}
                    required={field.required}
                    onChange={v => this.setState({ [field.id]: v })}
                  /> : `Unknown field type "${field.type}"`;
                })()}
              </div>
            </div>)}
          <Button primary raised type="submit" label="Create task" style={{ marginTop: '10px' }} />
        </form>
      </div>
    );
  }

  renderUpdate() {
    const task = this.state.item;
    return (
      <div style={{ padding: '10px' }}>
        <div style={{ marginBottom: '10px' }}>Update task #{task.sku} - {types[task.type] ? types[task.type].label : 'Unknown type'}</div>
        <form
          onSubmit={e => {
            e.preventDefault();
            const { type, loading, item, ...values } = this.state;
            update(this.props.dispatch, this.context.apiClient, task.id, values)
              .then(() => this.context.dialogClose(this.props.dialogId));
          }}
        >
          {(types[task.type] ? types[task.type].fields : []).map(field =>
            <div className={styleLocal.titleRow} key={field.id}>
              {field.label && <div className={styleLocal.title}>
                {field.label}
                {field.required && <div className={styleLocal.required}>*</div>}
              </div>}
              <div className={styleLocal.value}>
                {(() => {
                  const Cmp = fields[field.type];
                  return Cmp ? <Cmp
                    key={field.id}
                    id={field.id}
                    value={this.state[field.id] !== undefined
                      ? this.state[field.id]
                      : task[field.id]
                    }
                    required={field.required}
                    onChange={v => this.setState({ [field.id]: v })}
                  /> : `Unknown field type "${field.type}"`;
                })()}
              </div>
            </div>)}
          <div style={{ marginTop: '10px' }}>
            <Button primary raised type="submit" label="Save task" />
            <Button
              className={styleLocal.buttonRemove}
              label="Delete"
              icon="clear"
              onClick={() => this.context.dialogPush('message', { content: 'Are you sure?', onConfirm: () => this.remove() })}
            />
          </div>
        </form>
      </div>
    );
  }

  renderContent() {
    if (this.state.loading) {
      return (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <Spinner style={{ display: 'inline-block' }} />
        </div>
      );
    }
    if (this.props.data.id && !this.state.item) {
      return (
        <div style={{ textAlign: 'center', padding: '20px' }}>
          Task not found
        </div>
      );
    }
    if (this.props.data.id) {
      return this.renderUpdate();
    }
    if (!this.state.type) {
      return (
        <div style={{ padding: '10px' }}>
          <div>Select the type of task</div>
          {Object.keys(types).map(type => <Button
            key={type}
            style={{ width: '100%', marginTop: '10px' }}
            className={styleLocal.buttonOutline}
            label={types[type].label}
            onClick={() => this.setState({ type })}
          />)}
        </div>
      );
    }
    return this.renderCreate();
  }

  render() {
    return (
      <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
        <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
          <IconButton className={styleDialog.closeButton} icon="close" onClick={() => this.context.dialogClose(this.props.dialogId)} />
          <div className={styleDialog.content}>
            {this.renderContent()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(Dialog);



// WEBPACK FOOTER //
// ./app/dialogs/TaskNew/index.js